import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import { loginRequest } from "../authConfig";
import mapImg from "../assets/New_Map.png";
import logoImg from "../assets/skyovi-logo.png";
import idLogo from "../assets/IntelliDropLogo-new.png";

function Login() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/projects");
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = () => {
    setError("");
    instance.loginRedirect(loginRequest).catch((err) => {
      if (err.errorCode !== "user_cancelled") {
        setError("Login failed. Please try again.");
        console.error("SSO Login failed", err);
      }
    });
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "#faf9f6" }}>
      <Box
        sx={{
          flex: 1,
          backgroundImage: `url(${mapImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#fff",
          px: 4,
        }}
      >
        <Paper
          elevation={0}
          sx={{ width: "100%", maxWidth: 500, p: 6, boxShadow: "none", bgcolor: "transparent" }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 0 }}>
            <Box component="img" src={logoImg} alt="brightspeed" sx={{ height: 80 }} />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
            <Box component="img" src={idLogo} alt="IntelliDrop" sx={{ height: 80, maxWidth: "100%" }} />
          </Box>
          {error && (
            <Typography color="error" sx={{ mb: 2 }} align="center">
              {error}
            </Typography>
          )}
          <Button
            variant="contained"
            fullWidth
            onClick={handleLogin}
            sx={{
              background: "#60A5FA",
              color: "#fff",
              fontWeight: 600,
              fontSize: "1.1rem",
              mb: 2,
              "&:hover": { background: "#3B82F6" },
              borderRadius: 1,
              py: 1.8,
            }}
          >
            Login with SSO
          </Button>
          <Divider sx={{ my: 2 }}>
            <Typography variant="body2" color="text.secondary">or</Typography>
          </Divider>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => navigate("/client-login")}
            sx={{
              borderColor: "#60A5FA",
              color: "#3B82F6",
              fontWeight: 600,
              fontSize: "1rem",
              mb: 6,
              "&:hover": { background: "#EFF6FF", borderColor: "#3B82F6" },
              borderRadius: 1,
              py: 1.5,
            }}
          >
            Client Login
          </Button>
          <Typography variant="body2" color="text.secondary" align="center">
            Copyright © 2025 | Skyovi
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

export default Login;























































